/**
 * Locates ONNX Runtime's wasm artifacts through Vite.
 *
 * ORT loads its runtime with a dynamic `import()` of a URL derived from
 * `env.wasm.wasmPaths`. Serving those files from `public/` looks like the
 * obvious answer and works in a production build, but breaks `vite dev`: Vite
 * explicitly does not support importing files in `public/` from JavaScript, and
 * the dynamic import 404s with a `?import` suffix.
 *
 * Importing them with `?url` instead hands Vite the dependency properly. It
 * serves them in dev and emits them as build assets, so the app stays entirely
 * self-hosted either way - no CDN, and no chance of the runtime drifting out of
 * sync with the bundled JS.
 *
 * The specific filename is the variant `onnxruntime-web/webgpu` loads; the
 * package publishes explicit subpath exports for it. If a future ORT release
 * switches variants, `initRuntime` will fail loudly at the first session rather
 * than silently falling back.
 */
import wasmUrl from 'onnxruntime-web/ort-wasm-simd-threaded.asyncify.wasm?url';
import mjsUrl from 'onnxruntime-web/ort-wasm-simd-threaded.asyncify.mjs?url';

export const ORT_WASM_PATHS = { wasm: wasmUrl, mjs: mjsUrl };
